(()=>{'use strict';
const doc=document;
const menuBtn=doc.querySelector('[data-menu-toggle]');const mobile=doc.getElementById('MobileMenu');
if(menuBtn&&mobile){menuBtn.addEventListener('click',()=>{const open=mobile.hidden;mobile.hidden=!open;menuBtn.setAttribute('aria-expanded',String(open));menuBtn.setAttribute('aria-label',open?'Cerrar menú':'Abrir menú')});mobile.addEventListener('click',e=>{if(e.target.closest('a')){mobile.hidden=true;menuBtn.setAttribute('aria-expanded','false')}})}
let toastTimeout;function toast(msg){const el=doc.getElementById('CartToast');if(!el)return;clearTimeout(toastTimeout);el.textContent=msg;el.hidden=false;toastTimeout=setTimeout(()=>{el.hidden=true},3100)}
doc.addEventListener('submit',async e=>{const form=e.target.closest('form[data-ajax-add],form[data-cy-menu-buy],form.product-form');if(!form)return;e.preventDefault();const btn=form.querySelector('button[type="submit"]');if(!btn||btn.disabled)return;btn.disabled=true;const initial=btn.innerHTML;btn.textContent='Agregando…';try{const payload=new FormData(form);payload.delete('return_to');const res=await fetch(window.Shopify?.routes?.root?window.Shopify.routes.root+'cart/add.js':'/cart/add.js',{method:'POST',body:payload,headers:{'Accept':'application/json'}});const data=await res.json();if(!res.ok)throw new Error(data.description||'No se pudo agregar');const cart=await (await fetch('/cart.js',{headers:{'Accept':'application/json'}})).json();doc.querySelectorAll('[data-cart-count]').forEach(x=>x.textContent=cart.item_count);toast('🦐 ¡Añadido al carrito! Puedes seguir comprando.')}catch(err){toast(err.message||'No se pudo agregar al carrito')}finally{btn.disabled=false;btn.innerHTML=initial}});
/* cy-quantity-controls-v2: controls de cantidad en menú y fichas */
doc.addEventListener('click',event=>{
 const button=event.target.closest('[data-qty-minus],[data-qty-plus]');
 if(!button)return;
 const group=button.closest('.cy-menu-quantity,.qty')||button.parentElement;
 const input=group.querySelector('input[name="quantity"],input');
 if(!input)return;
 const current=parseInt(input.value,10)||1;
 const next=button.hasAttribute('data-qty-plus')?current+1:current-1;
 input.value=String(Math.max(1,Math.min(99,next)));
 input.dispatchEvent(new Event('input',{bubbles:true}));
 input.dispatchEvent(new Event('change',{bubbles:true}));
});
doc.querySelectorAll('[data-variant-select]').forEach(sel=>{sel.addEventListener('change',()=>{const o=sel.selectedOptions[0];const block=sel.closest('[data-product-detail]');if(!block)return;const el=block.querySelector('[data-variant-price]');if(el&&o.dataset.price)el.textContent=o.dataset.price;const hero=block.querySelector('#MainProductImage');if(hero&&o.dataset.image)hero.src=o.dataset.image;const submit=block.querySelector('button[type="submit"]');if(submit){submit.disabled=o.dataset.available==='false';submit.textContent=o.dataset.available==='false'?'Agotado':'Agregar al carrito →'}})});
doc.querySelectorAll('[data-thumb]').forEach(btn=>btn.addEventListener('click',()=>{const target=doc.getElementById(btn.dataset.target);if(target){target.src=btn.dataset.src;target.alt=btn.dataset.alt||target.alt}}));
doc.querySelectorAll('[data-menu-tabs]').forEach(holder=>{const buttons=Array.from(holder.querySelectorAll('[role="tab"]'));const panels=Array.from(doc.querySelectorAll('[data-menu-panel]'));buttons.forEach((btn,i)=>{btn.addEventListener('click',()=>{buttons.forEach(x=>{x.setAttribute('aria-selected',String(x===btn));x.tabIndex=x===btn?0:-1});panels.forEach(x=>x.hidden=x.dataset.menuPanel!==btn.dataset.tab);});btn.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();const idx=(i+(e.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;buttons[idx].focus();buttons[idx].click()}})})});

/* cy-menu-totals-v2: cálculo correcto con el precio de Shopify */
function updateMenuLineTotal(input){
 const form=input.closest('form[data-cy-menu-buy]');
 if(!form)return;
 const total=form.querySelector('[data-cy-line-total]');
 if(!total)return;
 const cents=Number(form.dataset.unitCents)||0;
 const raw=Number.parseInt(input.value,10);
 const qty=Number.isFinite(raw)?Math.max(1,Math.min(99,raw)):1;
 total.textContent='$'+((cents*qty)/100).toFixed(2);
}
doc.addEventListener('input',event=>{
 const input=event.target.closest('form[data-cy-menu-buy] input[name="quantity"]');
 if(input)updateMenuLineTotal(input);
});
doc.addEventListener('change',event=>{
 const input=event.target.closest('form[data-cy-menu-buy] input[name="quantity"]');
 if(!input)return;
 const qty=Number.parseInt(input.value,10);
 input.value=String(Number.isFinite(qty)?Math.min(99,Math.max(1,qty)):1);
 updateMenuLineTotal(input);
});
doc.querySelectorAll('form[data-cy-menu-buy] input[name="quantity"]').forEach(updateMenuLineTotal);

/* cy-cart-discount-entry-v1: cupón privado validado por Shopify, no se calcula descuento ficticio */
doc.addEventListener('submit',event=>{
 const form=event.target.closest('form[data-cy-discount-form]');
 if(!form)return;
 event.preventDefault();
 const field=form.querySelector('input[name="discount"]');
 const status=form.querySelector('[data-cy-coupon-status]');
 const code=(field?.value||'').trim();
 if(!code){if(status)status.textContent='Escribe tu código de descuento.';field?.focus();return;}
 const root=window.Shopify?.routes?.root||'/';
 const base=root.endsWith('/')?root:root+'/';
 const destination=base+'checkout';
 window.location.assign(base+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(destination));
});

/* CevichesYa: selección de sucursal y datos obligatorios antes del checkout. */
const cyBranch=doc.querySelector('[data-cy-branch-select]');
if(cyBranch){
  const cyCheckout=doc.querySelector('[data-cy-branch-checkout]');
  const cyBranchStatus=doc.querySelector('[data-cy-branch-status]');
  const cyCustomerStatus=doc.querySelector('[data-cy-customer-status]');
  const cyId=doc.querySelector('[data-cy-cedula]');
  const cyService=doc.querySelector('[data-cy-service]');
  const cyHouse=doc.querySelector('[data-cy-house]');
  const cyHouseWrap=doc.querySelector('[data-cy-house-wrap]');
  const cyRoot=window.Shopify?.routes?.root||'/';
  const cyBase=cyRoot.endsWith('/')?cyRoot:cyRoot+'/';
  let cySaving=false;
  function cyUpdateHouse(){
    const needsHouse=cyService?.value==='Entrega a domicilio';
    if(cyHouseWrap)cyHouseWrap.hidden=!needsHouse;
    if(cyHouse)cyHouse.required=needsHouse;
  }
  cyUpdateHouse();
  cyService?.addEventListener('change',cyUpdateHouse);
  cyId?.addEventListener('input',()=>{
    cyId.value=cyId.value.replace(/[^0-9]/g,'').slice(0,10);
    cyId.setCustomValidity('');
  });
  async function cySaveAttributes(all){
    if(cySaving)return false;
    const branch=cyBranch.value;
    if(!branch){
      cyBranch.focus();
      if(cyBranchStatus)cyBranchStatus.textContent='Selecciona tu sucursal para continuar.';
      return false;
    }
    if(all){
      if(!cyId || !/^[0-9]{10}$/.test(cyId.value.trim())){
        cyId?.setCustomValidity('Ingresa los 10 dígitos de tu cédula.');
        cyId?.reportValidity();
        cyId?.focus();
        return false;
      }
      cyId.setCustomValidity('');
      if(!cyService?.value){
        cyService?.reportValidity();cyService?.focus();return false;
      }
      if(cyService.value==='Entrega a domicilio'&&!cyHouse?.value.trim()){
        cyHouse?.setCustomValidity('Indica el número de casa o una referencia.');
        cyHouse?.reportValidity();cyHouse?.focus();return false;
      }
      cyHouse?.setCustomValidity('');
    }
    const attributes={'Sucursal de preparación':branch};
    if(all){
      attributes['Cédula']=cyId.value.trim();
      attributes['Modalidad solicitada']=cyService.value;
      attributes['Número de casa / referencia']=cyService.value==='Entrega a domicilio'?cyHouse.value.trim():'';
    }
    cySaving=true;
    if(cyBranchStatus)cyBranchStatus.textContent='Guardando sucursal…';
    try{
      const response=await fetch(cyBase+'cart/update.js',{
        method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({attributes})
      });
      if(!response.ok)throw new Error('No se guardaron los datos.');
      if(cyBranchStatus)cyBranchStatus.textContent='✓ Sucursal guardada: '+branch;
      if(all&&cyCustomerStatus)cyCustomerStatus.textContent='✓ Datos guardados correctamente.';
      return true;
    }catch(error){
      if(cyCustomerStatus)cyCustomerStatus.textContent='No pudimos guardar los datos. Intenta nuevamente.';
      if(cyBranchStatus)cyBranchStatus.textContent='Error al guardar. Intenta nuevamente.';
      return false;
    }finally{cySaving=false;}
  }
  cyBranch.addEventListener('change',()=>{cySaveAttributes(false);});
  cyHouse?.addEventListener('input',()=>cyHouse.setCustomValidity(''));
  const cyCartForm=doc.getElementById('CyCartItems');
  if(cyCartForm)cyCartForm.addEventListener('submit',async e=>{
    if(e.submitter?.name!=='checkout')return;
    e.preventDefault();
    if(cySaving){
      if(cyCustomerStatus)cyCustomerStatus.textContent='Se están guardando los datos. Vuelve a pulsar Finalizar compra.';
      return;
    }
    if(cyCheckout){cyCheckout.disabled=true;cyCheckout.textContent='Verificando datos…';}
    const saved=await cySaveAttributes(true);
    if(saved)window.location.assign(cyBase+'checkout');
    else if(cyCheckout){cyCheckout.disabled=false;cyCheckout.innerHTML='Finalizar compra <span aria-hidden="true">→</span>';}
  });
}
})();
